import { styled } from '@mui/material'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { COLORS } from '../../styles/colors'
interface ButtonUIProps {
	height?: string
	width?: string
	intent?: 'primary' | 'error'
}
export const OutlinedButton = styled(Button, {
	shouldForwardProp: prop =>
		typeof prop === 'string' && !['height', 'width', 'variant'].includes(prop),
})<ButtonUIProps>(({
	height = '56px',
	width = '27.7vw',
	intent = 'primary',
}) => {
	const mainColor = intent === 'error' ? COLORS.error : COLORS.main

	return {
		backgroundColor: 'transparent',
		color: mainColor,
		height: height,
		width: width,
		fontSize: '16px',
		fontWeight: '600',
		textTransform: 'none',
		border: `1px solid ${mainColor}`,
		borderRadius: '12px',
		'&:hover': {
			backgroundColor: mainColor,
			color: 'white',
			boxShadow: '0px 4px 16px rgba(82, 34, 208, 0.4)',
		},
		'&:disabled': {
			color: 'white',
			backgroundColor: COLORS.secondaryFontOpacity,
			border: `1px solid ${COLORS.secondaryFontOpacity}`,
		},
	}
})

export const ArrowButton = styled(IconButton)(() => ({
	position: 'absolute',
	right: '8px',
	top: '50%',
	transform: 'translateY(-50%)',
}))
